import React, { memo } from 'react';
import { createUseStyles, Text, Link } from '@Sage/hoi-poi-ui';

import { useWeb5Context } from 'lib/Web5Context';
import ContactAdmin from '../icons/ContactAdmin';

import styles from './styles';
const useStyles = createUseStyles(styles, 'Contact');

const Contact = () => {
    const classes = useStyles();
    const { t } = useWeb5Context();

    return (
        <div className={classes.root}>
            <div className={classes.intro}>
                <ContactAdmin className={classes.icon} />
                <Text className={classes.text}>{t('cfm_label_2fa_modify_phone_number_desc')}</Text>
                <Link href={t('cfm_label_2fa_modify_phone_more_info')} target="_blank">
                    {t('cfm_action_2fa_modify_phone_more_info')}
                </Link>
            </div>
        </div>
    );
};

export default memo(Contact);
